import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Constants } from 'utils';
import { Redirect, useLocation } from 'react-router-dom'; // useLocation para leer la URL actual con sus variables

const Home = () => {
  const user = useSelector((state: RootState) => state.user);
  // Leemos la URL actual (incluyendo query params como ?welcome=true)
  const location = useLocation();

  if (!user) {
    return <Redirect to='/login' />;
  } else {
    switch (user?.level_id) {
      case Constants.LEVELS.ADMIN:
        return <Redirect to='/admin' />;
        break;

      case Constants.LEVELS.MODERATOR:
        return <Redirect to='/admin' />;
        break;

      case Constants.LEVELS.CLIENT:
        return <Redirect to={{ pathname: '/client', search: location.search }} />;
        break;

      case Constants.LEVELS.LAWYER:
        return <Redirect to={{ pathname: '/lawyer', search: location.search }} />;

      default:
        return <Redirect to={{ pathname: '/profile', search: location.search }} />;
    }
  }
};

export default Home;
